import React from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'reactstrap';
import WarningToggle from './WarningToggle';
import WarningList from "shared/virtual_line_modal/components/WarningList";

export default class WarningDropdown extends React.Component {
  static propTypes = {
    warnings: PropTypes.array
  };

  static defaultProps = {
    warning: []
  };

  state = { open: false };

  toggle = () => {
    this.setState({ open: !this.state.open });
  }

  render() {
    const { warnings } = this.props;
    const { open } = this.state;

    return (
      <div data-label="warning-dropdown" className="alert alert-warning" style={{ display: this.displayType(), marginTop: "10px", marginBottom: "10px" }}>
        <div className="alert-message">
          <p style={{ marginBottom: "5px" }} data-label="dropdown-title">
            You have selected numbers that cannot be moved. These numbers will be skipped should you choose to proceed
          </p>
          <WarningToggle open={open} toggle={this.toggle} count={warnings.length}/>
          <Collapse isOpen={open}>
            <WarningList warnings={warnings} />
          </Collapse>
        </div>
      </div>
    );
  }

  displayType() {
    if (this.props.warnings.length > 0) {
      return "block";
    } else {
      return "none";
    }
  }
}
